import { subscriptionBadgeSizeToPx } from '../logoBadgeSizeToPx';
import { SubscriptionBadgeBadgeProps } from '../types';
import peakIconSrc from './peak-icon.svg';
import peakIconCircleSrc from './peak-icon-circle.svg';
import peakFullLightTextSrc from './peak-full-light-text.svg';
import peakFullDarkTextSrc from './peak-full-dark-text.svg';

const getSvgSrc = ({ variant, textColor }: SubscriptionBadgeBadgeProps) => {
  switch (variant) {
    case 'icon':
      return peakIconSrc;
    case 'icon-circle':
      return peakIconCircleSrc;
    case 'full':
      if (textColor === 'light') {
        return peakFullLightTextSrc;
      }
      return peakFullDarkTextSrc;
    default:
      return peakFullDarkTextSrc;
  }
};

const PeakLogoBadge = ({ className, size = 'md', variant, textColor }: SubscriptionBadgeBadgeProps) => {
  // TODO: Placeholder ticket to determine if alt text is needed https://alltrails.atlassian.net/browse/GROW-10485

  // In mugen, next/image automatically calculates the width of the image based on the height and the aspect ratio.
  // We need to do this manually for the regular img tag.
  const fullVariantAspectRatio = 2.542;
  const aspectRatio = variant === 'full' ? fullVariantAspectRatio : 1;
  const width = subscriptionBadgeSizeToPx[size] * aspectRatio;

  return (
    <img
      className={className}
      src={getSvgSrc({ variant, textColor })}
      height={subscriptionBadgeSizeToPx[size]}
      width={width}
      title="Peak"
      alt="Peak"
    />
  );
};

export default PeakLogoBadge;
